/**
 * Construit le payload à transmettre au service / template d'urgence
 * @param {Object} formData - Les données du formulaire Contact (nom, email, sujet, message, isUrgent, telephone)
 * @param {Object|null} previousStepData - Données récoltées aux étapes précédentes (ex: recensement)
 * @returns {Object} Payload avec les variables {{name}}, {{email}}, {{objet}}, {{time}}, {{message}}
 */
export function buildEmergencyPayload(formData, previousStepData = null) {
  const now = new Date();
  const timeFormatted = now.toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  const isUrgent = Boolean(formData.isUrgent);

  // Nom complet combiné si prénom disponible dans les étapes précédentes
  let fullName = formData.nom ? formData.nom.trim() : '';
  if (previousStepData?.prenom && !fullName.toLowerCase().includes(previousStepData.prenom.toLowerCase())) {
    fullName = `${previousStepData.prenom} ${fullName}`.trim();
  }

  // Construction de l'objet du message
  const objet = formData.sujet ? formData.sujet.trim() : 'Sans objet';

  // Corps du message principal
  let enrichedMessage = formData.message ? formData.message.trim() : '';

  const metaSections = [];

  if (formData.telephone || previousStepData?.telephone) {
    const phone = formData.telephone || previousStepData?.telephone;
    metaSections.push(`Téléphone / WhatsApp : ${phone}`);
  }

  if (previousStepData) {
    if (previousStepData.cin_passeport) {
      metaSections.push(`N° CIN / Passeport : ${previousStepData.cin_passeport}`);
    }
    if (previousStepData.filiere || previousStepData.universite) {
      metaSections.push(`Établissement / Filière : ${previousStepData.universite || ''} (${previousStepData.filiere || 'N/C'})`);
    }
    if (previousStepData.situation) {
      metaSections.push(`Situation : ${previousStepData.situation}`);
    }
  }

  if (metaSections.length > 0) {
    enrichedMessage += `\n\n` + metaSections.join('\n');
  }

  return {
    nom: fullName,
    email: formData.email ? formData.email.trim() : '',
    objet: objet,
    time: timeFormatted,
    message: enrichedMessage,

    // Propriétés supplémentaires directes pour d'éventuels templates EmailJS
    is_urgent: isUrgent,
    telephone: formData.telephone || previousStepData?.telephone || 'Non renseigné',
    cin_passeport: previousStepData?.cin_passeport || 'N/A',
  };
}
